import React, { useEffect, useState } from 'react';
import { Megaphone } from 'lucide-react'
import ModalStateLess from '../ModalStateLess';
import { use } from 'react';
import { api_bd_nr } from '../../services/Api';
import { useRecoilValue } from 'recoil';
import { profileData } from '../../atoms/user.atom'


const Content = (props) => {
    const [infractionsList, setInfractionsList] = useState([])
    const [valueInfraction, setValueInfraction] = useState({})
    const [idTicket, setIdTicket] = useState(0)
    const [timeInfraction, setTimeInfraction] = useState('')
    const [descInfraction, setDescInfraction] = useState('')
    const profileUser = useRecoilValue(profileData)

    // console.log('profileUser', profileUser)

    const loadInfractionsList = () => {
        api_bd_nr.get('/performance-radar?q=infractionslist')
            .then(({ data }) => {
                setInfractionsList([
                    ...data,
                    {
                        name: "Outro",
                        desc: "Outro",
                        point: 0
                    }
                ])
            })
            .catch(e => {
                console.log('error to load infractions list: ', e)
            })
    }

    useEffect(() => {
        loadInfractionsList()
    }, [])

    return (
        <div className='flex flex-col gap-4'>
            <div className='flex flex-col'>
                <h2 className='text-xl font-bold'>Informe de penalidade</h2>
                <span className='m-0'>Aqui você pode informar uma penalidade anonimamente.</span>
            </div>

            <div className='mt-5 flex flex-col'>
                <span className='m-0'>Tipo de penalidade</span>
                <select
                    className='p-2 m-0 border rounded'
                    value={JSON.stringify(valueInfraction)}
                    onChange={(e) => {
                        if (e.target.value === '') {
                            return
                        }
                        setValueInfraction(JSON.parse(e.target.value))
                    }}
                >
                    {infractionsList?.length === 0 &&
                        <option value=''>Carregando lista de infrações...</option>
                    }

                    {infractionsList.map((el, index) => (
                        <option key={`infr_${index}`} value={JSON.stringify(el)}>{el.name}</option>
                    ))}
                </select>
            </div>

            <div className='flex flex-col'>
                <span className='m-0'>ID do ticket</span>
                <input
                    type='number'
                    className='p-2 m-0 border rounded'
                    placeholder='0000'
                    value={idTicket}
                    onChange={(e) => {
                        setIdTicket(e.target.value)
                    }}
                />
            </div>

            <div className='flex flex-col'>
                <span className='m-0'>Horário</span>
                <input
                    type='time'
                    className='p-2 m-0 border rounded'
                    placeholder='0000'
                    value={timeInfraction}
                    onChange={(e) => {
                        setTimeInfraction(e.target.value)
                    }}
                />
            </div>

            <div className='flex flex-col'>
                <span className='m-0'>Descrição</span>
                <textarea
                    className='p-2 m-0 border rounded'
                    placeholder='Descreva o motivo da penalidade'
                    onChange={(e) => {
                        setDescInfraction(e.target.value)
                    }}
                >{descInfraction}</textarea>
            </div>

            <button
                className='mt-2 p-2 bg-blue-900 text-white rounded font-bold'
                onClick={() => {
                    if(!valueInfraction?.name || valueInfraction?.name === "Selecione uma infração"){
                        alert('Selecione um tipo de penalidade')
                        return
                    }

                    if(idTicket === 0 && descInfraction === ''){
                        alert('Preencha o ID do ticket ou a descrição da penalidade')
                        return
                    }

                    
                    api_bd_nr.post('/performance-radar/penaltyreport', {
                        idu: profileUser?.id,
                        valueInfraction,
                        idTicket,
                        timeInfraction,
                        descInfraction,
                        month: props.selectedMonth,
                        year: new Date().getFullYear()
                    }).then(({ data }) => {
                        alert('Penalidade informada com sucesso')
                        if (props?.hideModal) {
                            props.hideModal()
                        }
                    }).catch(e => {
                        alert('Erro ao informar penalidade, tente novamente, caso o problema persista entre em contato com o suporte')
                    })
                }}>Salvar</button>
        </div>
    )
}


function PenaltyReport({ selectedMonth }) {
    const [showModal, setShowModal] = useState(false)

    // const loadAnnonimousInformation = () => {
    //     api_bd_nr.get('/performance-radar/penaltyreport', {
    //         params: {
    //             month: selectedMonth,
    //             year: new Date().getFullYear()
    //         }
    //     })
    //         .then(({ data }) => {
    //             // console.log('loadAnnonimousInformation: ', data)
    //         })
    //         .catch(e => {
    //             console.log('error to load infractions list: ', e)
    //         })
    // }

    // useEffect(() => {
    //     // loadAnnonimousInformation()
    // }, [selectedMonth])

    return (
        <div className='pr-4'>
            <Megaphone
                className='cursor-pointer'
                onClick={() => setShowModal(true)}
            />
            
            <ModalStateLess
                show={showModal}
                content={<Content selectedMonth={selectedMonth} hideModal={() => { setShowModal(false) }}  />}
                hideModal={() => { setShowModal(false) }}
            />
        </div>
    );
}

export default PenaltyReport;
